const menuItems = [
	{
		id		: 1,
		title	: 'Social Media Data Dashboard',
		color	: 'rgba(61, 61, 87, 0.3)',
		link		: '/socialMedia'
	},
	{
		id		: 2,
		title	: 'Market Data Dashboard',
		color	: 'rgba(61, 61, 87, 0.3)',
		link		: '/marketData'
	},
	{
		id		: 3,
		title	: 'Discourse Dashboard',
		color	: 'rgba(61, 61, 87, 0.3)',
		link		: '/discourse'
	},
	{
		id		: 4,
		title	: 'Ga & Seo Dashboard',
		color	: 'rgba(61, 61, 87, 0.3)',
		link		: '/googleAnalytics'
	},
	{
		id		: 5,
		title	: 'Quest & POAPs Dashboard',
		color	: 'rgba(61, 61, 87, 0.3)',
		link		: '/questAndPoap'
	},
	{
		id		: 6,
		title	: 'Weekly Summary',
		color	: 'rgba(61, 61, 87, 0.3)',
		link		: '/summary'
	},
	/*
	{
		parent_id	: 1,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 1,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 2,
		icon		: polygonLogo,
		title	: 'Polygon',
		color	: 'rgba(130, 71, 229, 0.3)',
	},
	{
		parent_id	: 2,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 2,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 2,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 2,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 3,
		icon		: avalancheLogo,
		title	: 'Avalanche',
		color	: 'rgba(232, 65, 66, 0.3)',
	},
	{
		parent_id	: 3,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 3,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 3,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 3,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 4,
		icon		: arbitrumLogo,
		title	: 'Arbitrum',
		color	: 'rgba(40, 159, 239, 0.3)',
	},
	{
		parent_id	: 4,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 4,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 4,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 4,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 5,
		icon		: bnbLogo,
		title	: 'BNB Chain',
		color	: 'rgba(243, 186, 44, 0.3)',
	},
	{
		parent_id	: 5,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 5,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 5,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 5,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 6,
		icon		: fantomLogo,
		title	: 'Fantom',
		color	: 'rgba(19, 181, 236, 0.3)',
	},
	{
		parent_id	: 6,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 6,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 6,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 6,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 7,
		icon		: ronLogo,
		title	: 'Ronin',
		color	: 'rgba(18, 115, 234, 0.3)',
	},
	{
		parent_id	: 7,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 7,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 7,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 7,
		title	: 'LooksRare',
		link		: ''
	},

	{
		id		: 8,
		icon		: solLogo,
		title	: 'Solana',
		color	: 'rgba(31, 241, 167, 0.3)',
	},
	{
		parent_id	: 8,
		title	: 'Axie Infinity',
		link		: ''
	},
	{
		parent_id	: 8,
		title	: 'Aave',
		link		: ''
	},
	{
		parent_id	: 8,
		title	: 'Lido',
		link		: ''
	},
	{
		parent_id	: 8,
		title	: 'LooksRare',
		link		: ''
	},
	*/
]


export default menuItems